module.exports = __webpack_public_path__ + "img/folder.466f3b00.gif";